import { pricingCalendarApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const PRICING_CALENDAR_ACTION_TYPE = createNamedActions('marginCenter/pricingCalendar', {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  GET_PRICING_CALENDAR: 'GET_PRICING_CALENDAR',
  SET_VERSIONS_LOADING: 'SET_VERSIONS_LOADING',
  SET_VERSIONS_ERROR: 'SET_VERSIONS_ERROR',
  GET_PRICING_CALENDAR_VERSIONS: 'GET_PRICING_CALENDAR_VERSIONS',
  SET_SAVING: 'SET_SAVING',
  SET_SAVE_ERROR: 'SET_SAVE_ERROR',
  UPSERT_PRICING_CALENDAR: 'UPSERT_PRICING_CALENDAR',
});

// DEV-4977/MC-13: the current company-wide pricing-calendar config (no channel scope, unlike guardrails).
export const getPricingCalendarAction = () => async dispatch => {
  dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.SET_LOADING, payload: true });

  try {
    const { data } = await pricingCalendarApi.getCurrent();

    return dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.GET_PRICING_CALENDAR, payload: data });
  } catch {
    return dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.SET_ERROR });
  }
};

export const getPricingCalendarVersionsAction = () => async dispatch => {
  dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.SET_VERSIONS_LOADING, payload: true });

  try {
    const { data } = await pricingCalendarApi.getVersions();

    return dispatch({
      type: PRICING_CALENDAR_ACTION_TYPE.GET_PRICING_CALENDAR_VERSIONS,
      payload: data,
    });
  } catch {
    return dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.SET_VERSIONS_ERROR });
  }
};

// Publishes a new pricing-calendar version, superseding the prior current row. Returns the saved row on
// success, null on failure — the caller surfaces the reduced errorMessage inline.
export const createPricingCalendarVersionAction = request => async dispatch => {
  dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.SET_SAVING, payload: true });

  try {
    const { data } = await pricingCalendarApi.createVersion(request);

    dispatch({ type: PRICING_CALENDAR_ACTION_TYPE.UPSERT_PRICING_CALENDAR, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: PRICING_CALENDAR_ACTION_TYPE.SET_SAVE_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};
